export default function deleteProducts(state, action) {
  let payload = []; // By default deleting all products if not storeId

  if (action.storeId) {
    payload = state.payload.filter(product => product.shop.id !== action.storeId);
  }

  return {...state, payload};
}